import { render } from "./selectcolumn.vue?vue&type=template&id=27179afe&scoped=true"
import script from "./selectcolumn.vue?vue&type=script&lang=js"
export * from "./selectcolumn.vue?vue&type=script&lang=js"

import "./selectcolumn.vue?vue&type=style&index=0&id=27179afe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27179afe"]])

export default __exports__